import { switchLogEnabled, restartApp, installComponent } from 'ServerAPI'
import * as ActionTypes from './ActionTypes'

export const setInstallVersion = payload => ({
  type: ActionTypes.SET_INSTALL_VERSION,
  payload,
})

export const setLogPath = payload => ({
  type: ActionTypes.SET_LOG_PATH,
  payload,
})


export const setEdition = edition => ({
  type: ActionTypes.SET_EDITION,
  payload: { edition },
})

export const setLogsEnabled = () => async (dispatch, getState) => {
  try {
    const { logsEnabled } = getState().app
    await switchLogEnabled(!logsEnabled)
    await restartApp()
  } catch (e) {
    console.error(`setLogsEnabled error: ${e}`)
  }
}

export const restartApplication = () => async () => {
  try {
    await restartApp()
  } catch (e) {
    console.error(`restartApplication error: ${e}`)
  }
}

export const installComponentAction = ({ component }) => async dispatch => {
  try {
    await installComponent({ component })
  } catch (e) {
    const messageKey = e?.response?.status === 403
      ? 'MESSAGE_BOX_INSTALL_RUNNING'
      : 'MESSAGE_BOX_INSTALL_FAILED'
    dispatch({ type: ActionTypes.SET_INSTALL_COMPONENT_ERROR, payload: messageKey })
  }
}

export const setConfig = config => ({
  type: ActionTypes.SET_CONFIG,
  payload: { config },
})
